import React from "react";
import "./AboutMe.css";

export default function About() {
    return (
            <div className="about-container">
                <h1>About Me</h1>
                <p>
                    I am a soon-to-be graduate with a master's degree in software engineering at Aalborg University. 
                    Through my tenure as a student at Aalborg University, I have gained experience in a number of software technologies. 
                    My specialities are Python, C#, JavaScript, and React.
                </p>
            </div>
    );
}